<template>
  <div>
    <SearchPannel @search="search" @expExcel="down" />
    <div class="pd-20">
      <a-table style="zoom:0.75" :columns="columns" :data-source="list" :pagination="pagination" @change="handleTableChange">
        <div slot="action" slot-scope="row">
          <a-button type="link" @click="$router.push('/main/order-detail?kdnOrderCode='+row.kdnOrderCode)">
            详情
          </a-button>
          <a-button type="link" @click="post(row)">
            物流投诉
          </a-button>
          <!-- <a v-if="row.tickets&&row.tickets.length>0" :href="'#/main/order-detail?kdnOrderCode='+row.kdnOrderCode">
            投诉信息 {{ row.tickets.length }}
          </a> -->
        </div>
        <a-button slot="logisticCode" slot-scope="row" type="link" @click="showLogisticPath(row)"  >
          {{ row.logisticCode }}
        </a-button>
        <span slot="cost" slot-scope="row">
          {{ row.custPayFreight }}
        </span>
        <div slot="sendInfo" slot-scope="row">
          <div>
            {{ row.fromName }}&nbsp;{{ row.fromMobile }}
          </div>
          <div>
            {{ (row.fromProvinceName||'')+(row.fromCityName||'')+(row.fromExpAreaname||'')+(row.fromAddress||'') }}
          </div>
        </div>
        <div slot="recieverInfo" slot-scope="row">
          <div>
            {{ row.toName }}&nbsp;{{ row.toMobile }}
          </div>
          <div>
            {{ (row.toProvinceName||'')+(row.toCityName||'')+(row.toExpAreaname||'')+(row.toAddress||'') }}
          </div>
        </div>
      </a-table>
    </div>
    <Complaint v-if="viz" :info="cinfo" :visible.sync="viz" @success="postSuccess" />
    <LogistPath :info="lInfo" :viz.sync="showPath" />
  </div>
</template>
<script>
import SearchPannel from './searchPannel'
import Complaint from '@/components/complaint'
import LogistPath from '@/components/path'

const columns = [
  { title: '下单时间', dataIndex: 'createTime', key: 'createTime' },
  { title: '寄件人信息', key: 'sendInfo', scopedSlots: { customRender: 'sendInfo' }},
  { title: '收件人信息', key: 'recieverInfo', scopedSlots: { customRender: 'recieverInfo' }},
  { title: '订单编号', dataIndex: 'orderCode', key: 'orderCode' },
  { title: '订单状态', dataIndex: 'orderStateName', key: 'orderStateName' },
  { title: '快递公司', dataIndex: 'shipperName', key: 'shipperName' },
  { title: '快递单号', scopedSlots: { customRender: 'logisticCode' }},
  // { title: '物流状态', scopedSlots: { customRender: 'logisticCode' }},
  { title: '运费（元）', key: 'cost', scopedSlots: { customRender: 'cost' }},
  { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }}
]
export default {
  components: {
    SearchPannel, Complaint, LogistPath
  },
  data() {
    return {
      showPath: false,
      viz: false,
      columns,
      cinfo: null,
      lInfo: null,
      params: {
        // 'endCreateDate': this.$moment().format('YYYY-MM-DD'),
        // 'startCreateDate': this.$moment().format('YYYY-MM-DD'),
        'endCreateDate': '',
        'startCreateDate': ''
      },
      list: [],
      pagination: {
        'current': 1,
        'pageSize': 10,
        total: 0
      },
      staffList: []
    }
  },
  created() {
    // this.getList()

  },
  methods: {
    showLogisticPath(info) {
      this.lInfo = info
      this.showPath = true
    },
    post(row) {
      console.log(row)
      this.cinfo = row
      this.viz = true
    },
    postSuccess() {
      this.viz = false
      this.getList()
    },
    async down(params) {
      if (params) {
        Object.assign(this.params, params)
      }
      this.params.pageIndex = this.pagination.current
      this.params.pageSize = this.pagination.pageSize
      this.$down(this.$api.orderExportOrderList, { ...this.params })
    },
    handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.getList()
    },
    search(params) {
      this.pagination.current = 1
      if (this.$store.state.user.role !== 3) {
        params.originCustomerId = this.$store.state.user.userId
      }
      this.getList(params)
    },
    async getList(params) {
      if (params) {
        Object.assign(this.params, params)
      }
      this.params.pageIndex = this.pagination.current
      this.params.pageSize = this.pagination.pageSize
      const res = await this.$http(this.$api.orderGetPageList, { ...this.params, orderOrigin: 2 })
      if (res) {
        this.list = res.list || []
        this.pagination.current = res.pageIndex
        this.pagination.pageSize = res.pageSize
        this.pagination.total = res.totalSize
        this.$emit('count', res.totalSize)
      }
    }
  }
}
</script>
